import React, {Component} from 'react';
import invoke from 'lodash.invoke';
import {withPickList} from '../context';
import PickListItem from '../Item';
import FilterList from '../../FilterList';
import {t} from '../../../util/i18n';

class PickList extends Component {

    static defaultProps = {
        maxResultCount: 7,
        enableSearchAtCount: 11,
        queryProps: [],
        searchPlaceholder: ''
    };

    onResultSelect = ( evt, result ) => {
        const {pickList} = this.props;
        invoke( pickList.actions, 'handleItemChange', result[pickList.itemIdProp] );
    };

    /**
     * Sort pluck current selectedItem from list and shift to front to improve user interaction
     */
    shiftSelectedItem ( list, selectedItem ) {
        if ( !selectedItem ) {
            return list;
        }

        const itemId = this.props.pickList.itemIdProp;
        const filteredList = list.filter( item => item[itemId] !== selectedItem[itemId] );
        return [selectedItem].concat( filteredList );
    }

    render () {
        const {pickList, itemRenderer, maxResultCount, searchPlaceholder, enableSearchAtCount, queryProps} = this.props;
        if ( !pickList.isEditing || pickList.list.length <= 0 ) {
            return null;
        }

        const sortedList = this.shiftSelectedItem( pickList.list, pickList.selectedItem );
        const listItemRenderer = item => <PickListItem {...item} renderer={itemRenderer}/>;

        return (
            <div data-testid="picklist-list">
                {pickList.allowAddItem &&
                    <div onClick={pickList.actions.toggleAddItem} className="button-add-item mb-2">
                    {t( 'pickList.actionLabel.addAnother', '＋ Add another' )} {pickList.itemType}
                </div>
                }

                <FilterList
                    onResultSelect={this.onResultSelect}
                    list={sortedList}
                    queryProps={queryProps}
                    renderer={listItemRenderer}
                    searchPlaceholder={searchPlaceholder}
                    maxLength={maxResultCount}
                    enableSearchAtCount={enableSearchAtCount}/>
            </div>

        );
    }
}

export default withPickList( PickList );
